function initCKEditor() {
  document.querySelectorAll("textarea.ckeditor").forEach((textarea) => {
    if (textarea.dataset.ckeditorInitialized) return;

    ClassicEditor
      .create(textarea)
      .then(editor => {
        textarea.dataset.ckeditorInitialized = "true";
      })
      .catch(error => {
        console.error("CKEditor error:", error);
      });
  });
}

document.addEventListener("turbo:load", initCKEditor);
document.addEventListener("turbo:frame-load", initCKEditor);
